class NumberCounter extends HTMLElement {
  constructor() {
    super();
    this.hasAnimated = false;
    this.observer = null;
  }

  connectedCallback() {
    this.target = parseFloat(this.dataset.target) || 0;
    this.textContent = '0';
    this.setupIntersectionObserver();
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  setupIntersectionObserver() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.hasAnimated) {
          this.startAnimation();
          this.hasAnimated = true;
        }
      });
    }, {
      threshold: 0.5,
      rootMargin: '0px 0px -50px 0px'
    });

    this.observer.observe(this);
  }

  startAnimation() {
    const duration = 3000; 
    const framerate = 60; 
    const totalFrames = Math.round(duration / (1000 / framerate));
    const increment = this.target / totalFrames;
    
    let currentFrame = 0;
    let currentValue = 0;

    const animate = () => {
      currentFrame++;
      currentValue = Math.min(increment * currentFrame, this.target);
      
      this.textContent = this.formatNumber(currentValue);
      
      if (currentFrame < totalFrames) {
        requestAnimationFrame(animate);
      } else {
        this.textContent = this.formatNumber(this.target);
      }
    };

    requestAnimationFrame(animate);
  }

  formatNumber(value) {
    const rounded = Math.round(value);
    return rounded.toLocaleString();
  }
}

customElements.define('number-counter', NumberCounter);
